import { useEffect, useState } from 'react';
import { db } from '../../ReactNative/firebase';
import {
    Text,
    Platform,
    SafeAreaView,
    View,
    FlatList,
    useColorScheme,
} from 'react-native';
import { onValue, ref } from 'firebase/database';

const PapaLadsScoreboard = () => {
    const isDarkMode = useColorScheme() === 'dark';

    const [dataHere, setData] = useState<
        Array<{ name: string; score: number; time: string }>
    >([]);

    useEffect(() => {
        const dbRef = ref(db, 'PapaLadsTriviaScoreboard/');

        const unsubscribe = onValue(dbRef, (snap) => {
            const data = snap.val();

            if (!data) {
                setData([]);
                return;
            }

            const array = Object.values(data) as Array<{
                name: string;
                score: number;
                time: string;
            }>;

            const sorted = array.sort((a, b) => b.score - a.score);

            setData(sorted);
        });

        return () => unsubscribe();
    }, []);

    return (
        <SafeAreaView
            style={{
                flex: 1,
                backgroundColor: isDarkMode ? '#000' : '#fff',
            }}
        >
            {/* HEADER */}
            <View
                style={{
                    paddingVertical: 20,
                    alignItems: 'center',
                }}
            >
                <Text
                    style={{
                        fontSize: 40,
                        textAlign: 'center',
                        color: '#b59410',
                        fontFamily:
                            Platform.OS === 'android'
                                ? 'serif'
                                : 'Noteworthy-bold',
                    }}
                >
                    Papa Ladz's 70th Scoreboard
                </Text>
            </View>

            {/* TABLE CONTAINER */}
            <View
                style={{
                    flex: 1,
                    margin: 10,
                    borderRadius: 20,
                    borderWidth: 2,
                    borderColor: '#b59410',
                    overflow: 'hidden',
                }}
            >
                {/* HEADER ROW */}
                <View
                    style={{
                        flexDirection: 'row',
                        paddingVertical: 10,
                        backgroundColor: 'rgba(181, 148, 16, 0.1)',
                    }}
                >
                    <Text
                        style={{
                            flex: 2,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: '#b59410',
                        }}
                    >
                        Name
                    </Text>

                    <Text
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: '#b59410',
                        }}
                    >
                        Score
                    </Text>

                    <Text
                        style={{
                            flex: 1,
                            textAlign: 'center',
                            fontSize: 22,
                            fontWeight: 'bold',
                            color: '#b59410',
                        }}
                    >
                        Time
                    </Text>
                </View>

                {/* LIST */}
                <FlatList
                    data={dataHere}
                    keyExtractor={(_, index) => index.toString()}
                    renderItem={({ item }) => (
                        <View
                            style={{
                                flexDirection: 'row',
                                paddingVertical: 10,
                                borderBottomWidth: 0.5,
                                borderBottomColor: 'rgba(181,148,16,0.2)',
                            }}
                        >
                            <Text
                                style={{
                                    flex: 2,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: isDarkMode ? '#fff' : '#111',
                                }}
                            >
                                {item.name}
                            </Text>

                            <Text
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: '#b59410',
                                    fontWeight: 'bold',
                                }}
                            >
                                {item.score}
                            </Text>

                            <Text
                                style={{
                                    flex: 1,
                                    textAlign: 'center',
                                    fontSize: 18,
                                    color: isDarkMode ? '#fff' : '#111',
                                }}
                            >
                                {item.time}s
                            </Text>
                        </View>
                    )}
                />
            </View>
        </SafeAreaView>
    );
};

export default PapaLadsScoreboard;